import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../styles/site.css";

const CoverPage = ({
  imageSrc,
  altText = "Cover Image",
  showContent = true,
  title,
  duration,
}) => {
  const hasTripDetails = Boolean(title || duration);

  if (!hasTripDetails && showContent) {
    return (
      <section className="home-hero">
        <img className="home-hero-img" src={imageSrc} alt={altText} />
        <div className="home-hero-shade" />
        <div className="container">
          <div className="home-hero-copy">
            <span className="home-hero-eyebrow">
              <i className="bi bi-compass" aria-hidden="true" />
              Indian Odyssey Trips
            </span>
            <h1>Discover your next adventure</h1>
            <p>Handpicked experiences across India. Flexible plans, transparent pricing, and friendly support.</p>
            <div className="home-hero-actions">
              <a href="#trips" className="home-btn home-btn-light">
                Explore trips <i className="bi bi-arrow-down" aria-hidden="true" />
              </a>
              <a href="#contact" className="home-btn home-btn-ghost">
                <i className="bi bi-chat-dots" aria-hidden="true" /> Talk to us
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      {/* Hero styles */}
      <style>
        {`
          .io-hero { position: relative; }
          .io-hero img { height: 86vh; object-fit: cover; object-position: center; }
          .io-hero .overlay { position: absolute; inset: 0; background: linear-gradient(180deg, rgba(2,6,23,.35) 0%, rgba(2,6,23,.65) 100%); }
          .io-hero .content { position: absolute; inset: 0; display: grid; place-items: center; color: #fff; text-align: center; padding: 0 16px; }
          .io-hero h1 { font-weight: 800; letter-spacing: -0.02em; }
          .io-hero p { max-width: 760px; margin: 0 auto; opacity: .95; }
          @media (max-width: 768px) { .io-hero img { height: 60vh !important; } }
        `}
      </style>

      <section className="io-hero">
        <img className="img-fluid w-100" src={imageSrc} alt={altText} />
        <div className="overlay" />
        {hasTripDetails ? (
          <div className="content">
            <div>
              {title && <h1 className="display-5 mb-3">{title}</h1>}
              {duration && <p className="lead mb-0">Duration: {duration}</p>}
            </div>
          </div>
        ) : null}
      </section>
    </>
  );
};

export default CoverPage;
